"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const intl_1 = require("@kyruus/intl");
const styles_1 = require("./styles");
const react_1 = __importDefault(require("react"));
const Warning_1 = __importDefault(require("@kyruus/react-ikons/Warning"));
const PhoneNumberLink_1 = __importDefault(require("../../../components/PhoneNumberLink/PhoneNumberLink"));
const messages_1 = __importDefault(require("../../lib/messages"));
const ErrorPageSharedContent = ({ errorHeadingText, bannerText, phone, type, icon }) => (react_1.default.createElement(styles_1.ErrorPageContentWrapper, null,
    errorHeadingText && (react_1.default.createElement(styles_1.ErrorHeading, null,
        react_1.default.createElement(Warning_1.default, { size: "36px" }),
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default[errorHeadingText])))),
    react_1.default.createElement(styles_1.StyledBanner, { type: type !== null && type !== void 0 ? type : 'info', icon: icon !== null && icon !== void 0 ? icon : 'i', "data-testid": "CancelDisabledErrorBanner" },
        react_1.default.createElement(intl_1.FormattedMessage, Object.assign({}, messages_1.default[bannerText], { values: phone
                ? {
                    phone_number_link: react_1.default.createElement(PhoneNumberLink_1.default, { phone: phone })
                }
                : undefined })))));
exports.default = ErrorPageSharedContent;
//# sourceMappingURL=ErrorPageSharedContent.js.map